import React from "react";
import { FaArrowRight } from "react-icons/fa6";
import { BTN_SIZE, H2_SIZE } from "../home/ui";

// Small shared pieces for the mobile-app page (blue theme).

export const Eyebrow = ({ children, line = true }) => (
  <p className="flex items-center gap-[12px] text-[12px] font-medium uppercase tracking-[0.12em] text-[#3B4A7A]">
    {children}
    {line && <span className="h-[2px] w-[40px] rounded-full bg-[#3D5AFE] max-sm:hidden" />}
  </p>
);

export const BlueButton = ({ href, children, className = "" }) => (
  <a
    href={href}
    className={`group inline-flex items-center rounded-full bg-gradient-to-r from-[#3D5AFE] to-[#2B44D8] ${BTN_SIZE} font-medium text-white shadow-[0_14px_30px_-14px_rgba(43,68,216,0.75)] transition hover:brightness-110 ${className}`}
  >
    {children}
    <FaArrowRight className="text-[13px] transition group-hover:translate-x-1" />
  </a>
);

export const H2 = ({ children, className = "" }) => (
  <h2 className={`font-bold tracking-tight text-[#0F1B4C] ${H2_SIZE} ${className}`}>{children}</h2>
);

// Fades all four edges of an image so its own background never shows as a box.
const fadeX = "linear-gradient(to right, transparent 0%, #000 8%, #000 94%, transparent 100%)";
const fadeY = "linear-gradient(to bottom, transparent 0%, #000 6%, #000 92%, transparent 100%)";
export const edgeFade = {
  WebkitMaskImage: `${fadeX}, ${fadeY}`,
  WebkitMaskComposite: "source-in",
  maskImage: `${fadeX}, ${fadeY}`,
  maskComposite: "intersect",
};
